import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import AgentMostConflicts from './AgentMostConflicts';
import TicketsByType from './TicketsByType';
import TicketsBySeverity from './TicketsBySeverity';
import TicketsByAgent from './TicketsByAgent';
import { ticketService } from '../../../services/ticketService';

const cardStyle = {
  background: 'linear-gradient(160deg, #161731 0%, #12132a 55%, #0f1024 100%)',
  border: '1px solid rgba(255,255,255,0.07)',
  boxShadow: '0 4px 24px rgba(0,0,0,0.35)',
  borderRadius: '12px',
  overflow: 'hidden',
};

const DashBoardSupport = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [agent, setAgent] = useState(null);
  const [ticketsType, setTicketsType] = useState([]);
  const [ticketsSeverity, setTicketsSeverity] = useState([]);
  const [agentStats, setAgentStats] = useState([]);

  useEffect(() => {
    fetchTickets();
    getTicketsByType();
    getTicketsBySeverity();
    getTicketsByProject();
  }, []);

  const fetchTickets = async () => {
    try {
      const { data, error } = await ticketService.mostTicketsOPen();
      if (!error) setAgent(data);
    } catch (err) {
      console.error('Error al obtener tickets:', err);
    }
  };

  const getTicketsByType = async () => {
    try {
      const { data, error } = await ticketService.fetchTicketsByType();
      if (!error) setTicketsType(data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const getTicketsBySeverity = async () => {
    try {
      const { data, error } = await ticketService.fetchTicketsBySeverity();
      if (!error) setTicketsSeverity(data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const getTicketsByProject = async () => {
    try {
      const { data, error } = await ticketService.fetchTicketsByProject();
      if (!error) setAgentStats(data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
      style={{ ...cardStyle, padding: '24px', position: 'relative' }}
    >
      {/* Accent top line */}
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, height: '2px',
        background: 'linear-gradient(90deg, #DC1F26 0%, #3B82F6 60%, #00C2FF 100%)',
      }} />

      <div className="space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-xl font-bold" style={{ color: '#E8EAF0' }}>Resumen de Soporte</h1>
          <p className="text-sm mt-1" style={{ color: '#4A5270' }}>Vista general de los tickets y desempeño de agentes</p>
        </div>

        {/* 3 stat cards */}
        <motion.div
          className="grid gap-4"
          style={{ gridTemplateColumns: '1fr 1fr 1fr', alignItems: 'stretch' }}
          initial="hidden"
          animate="visible"
          variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.07 } } }}
        >
          <motion.div variants={{ hidden: { opacity: 0, y: 14 }, visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: [0.16,1,0.3,1] } } }}>
            <AgentMostConflicts agent={agent} />
          </motion.div>
          <motion.div variants={{ hidden: { opacity: 0, y: 14 }, visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: [0.16,1,0.3,1] } } }}>
            <TicketsByType ticketsByType={ticketsType} />
          </motion.div>
          <motion.div variants={{ hidden: { opacity: 0, y: 14 }, visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: [0.16,1,0.3,1] } } }}>
            <TicketsBySeverity ticketsSeverity={ticketsSeverity} />
          </motion.div>
        </motion.div>

        {/* Expand section */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: '12px' }}>
          <button
            onClick={() => setIsExpanded(prev => !prev)}
            className="flex items-center gap-2 text-sm font-semibold transition-colors"
            style={{ color: '#9BA3B8', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
            onMouseEnter={e => e.currentTarget.style.color = '#E8EAF0'}
            onMouseLeave={e => e.currentTarget.style.color = '#9BA3B8'}
          >
            Desempeño por Agente
            <span style={{
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              width: 24, height: 24, borderRadius: '50%',
              background: 'rgba(59,130,246,0.15)',
              border: '1px solid rgba(59,130,246,0.3)',
              color: '#60A5FA',
              transition: 'transform 0.2s',
              transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
            }}>
              <FaChevronDown size={10} />
            </span>
          </button>

          <AnimatePresence>
            {isExpanded && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                style={{ overflow: 'hidden', marginTop: '16px' }}
              >
                <TicketsByAgent agentStats={agentStats} />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </motion.div>
  );
};

export default DashBoardSupport;
